(function packageSearchForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'PackageSearch',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		Adzuki.Web.DualCalendar.initOnForm($form);

		$form.find('select.cruise-line').change(function onCruiseLineChange()
		{
			var $self        = $(this),
			    $shipField   = $form.find('select.ship'),
			    ship_options = [];

			ship_options.push(
				$('<option>').text('Choose Ship').attr('value', '')
			);

			if ($.trim($self.val())) {
				Adzuki.Ajax.get('/CruiseSearch/getShips/' + $self.val())
				.then(function populateShipSelect(response)
				{
					var response_data;

					response_data = Adzuki.Sort.alphabeticValue(response);

					$.each(response_data, function iterateShipResponse(key, item)
					{
						ship_options.push(
							$('<option>').text(item.value).attr('value', item.key)
						);
					});

					$shipField.empty();
					$shipField.append(ship_options);
				});
			} else {
				$shipField.empty();
				$shipField.append(ship_options);
			}

			
		});

		// Set dual calendar arrival date to be one month after departure
		$form.find('input.start-date').on('dp.change', function onStartDateChange(event, args)
		{
			args.linked_dtp.date(args.date_obj.add(1, 'month'));
		});
	};
}(jQuery, window.Adzuki || {}));
